import { SxProps, Theme } from '@mui/material';

export const OrderHistoryTrackOrderStepsFrameSX: SxProps = {
	display: 'flex',
	justifyContent: 'space-between',
	flexDirection: 'column',
	width: '100%',
	backgroundColor: '#F7F7F8',
	gap: 1,
	paddingX: 2,
	paddingY: 3,
};

export const OrderHistoryTrackOrderStepsLabelsSX: SxProps = {
	flex: 1,
	display: 'flex',
	flexDirection: 'row',
	gap: 1,
};

export const OrderHistoryTrackOrderStepsSingleLabelSX =
	(status: string): SxProps<Theme> =>
	(theme) => ({
		fontSize: 'var(--font-size-small)',
		fontWeight: 700,
		color: 'CANCELLED' === status ? theme.palette.error.main : '#2682E7',
	});

export const OrderHistoryTrackOrderStepsLabelSX =
	(index: number, currentStep: number, stepsLength: number, status: string): SxProps<Theme> =>
	(theme) => ({
		width: '100%',
		fontSize: 'var(--font-size-small)',
		fontWeight:
			'CANCELLED' === status && index === 0 ? 700 : index === currentStep ? 700 : undefined,
		color:
			'CANCELLED' === status && index === 0
				? theme.palette.error.main
				: index <= currentStep
				? '#2682E7'
				: '#929292',
		textAlign: index === 0 ? 'start' : index === stepsLength - 1 ? 'end' : 'center',
	});

export const OrderHistoryTrackOrderStepsBarFrameSX: SxProps = {
	width: '100%',
	height: 6,
	backgroundColor: '#CCCCCC',
	borderRadius: 3,
};

export const OrderHistoryTrackOrderStepsBarSX = (currentStep: number): SxProps => ({
	width: `${(currentStep + 1) * 25}%`,
	height: '100%',
	backgroundColor: '#2682E7',
	borderRadius: 3,
});
